import { trackSegmentAndGAEvent } from '@zoopla/tracking';

const eventCategory = 'situation';
const trackingPrefix = (page?: string) =>
    page === '/register/' ? '' : 'auth: ';

export const trackQuestionShown = (questionName: string, page: string) => {
    trackSegmentAndGAEvent(
        'Module Shown',
        {
            eventCategory,
            eventAction: 'module_shown',
            eventLabel: `${trackingPrefix(page)}${questionName}`
        },
        page
    );
};

export const trackQuestionSaved = (
    questionName: string,
    value: string,
    page: string
) => {
    trackSegmentAndGAEvent(
        'Module Interaction',
        {
            eventCategory,
            eventAction: 'click',
            eventLabel: `${trackingPrefix(page)}${questionName}: ${value}`
        },
        page
    );
};

export const trackQuestionEdit = (
    questionName: string,
    value: string,
    page: string
) => {
    trackSegmentAndGAEvent(
        'Module Interaction',
        {
            eventCategory,
            eventAction: 'click',
            eventLabel: `${trackingPrefix(page)}${questionName}: ${value} edit`
        },
        page
    );
};

export const trackQuestionError = (
    questionName: string,
    value: string,
    page: string
) => {
    trackSegmentAndGAEvent(
        'Module Interaction',
        {
            eventCategory,
            eventAction: 'error_shown',
            eventLabel: `${trackingPrefix(page)}${questionName}: ${value}`
        },
        page
    );
};

export const trackQuestionSkip = (questionName: string, page: string) => {
    trackSegmentAndGAEvent(
        'Module Interaction',
        {
            eventCategory,
            eventAction: 'click',
            eventLabel: `${trackingPrefix(page)}${questionName} skip`
        },
        page
    );
};
